import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { UseVideoContext } from "../Contexts/VideoContext";
import VideoListMultiRow from "./VideoListMultiRow";
import VideoListSingleRow from "./VideoListSingleRow";
import Ad from "../Generic/Ad";
import useIsMobile from "../../Hooks/useIsMobile";

function VideoList(props) {
  const [videos, SetVideos] = useState([]);
  const [searchParams] = useSearchParams();

  const { GetVideos, ChangeRecommendedVideos } = UseVideoContext();

  const { isMobile } = useIsMobile();

  async function RetrieveVideos() {
    if (props.videos != null) {
      SetVideos(props.videos);
      return;
    }

    const targetAmount = props.amount ?? 20;
    const hasListVideoPlayer = props.topVideo != null;
    const needExtraOnFirst = hasListVideoPlayer && props.loadsCompleted === 1;
    const requestedAmount = targetAmount + (needExtraOnFirst ? 1 : 0);

    const params = {
      amount: requestedAmount,
      random: props.random ?? false,
      search: props.search ?? null,
      categories: props.categories ?? null,
      channel: props.channel ?? null,
      sortBy: props.sortBy ?? "date",
      startDate: props.startDate ?? null,
      endDate: props.endDate ?? null,
      page: props.loadsCompleted ?? null,
      ids: props.videoIds ?? null,
      includeTotalPages: props.includeTotalPages ?? false,
      password: searchParams.get("cat_pas"),
    };

    let genericVideos = await GetVideos(params);
    if (genericVideos.error) {
      return;
    }

    let resultRows = genericVideos.data ?? [];

    // Server returns ["totalPages:N", ...videos] when includeTotalPages is true.
    if (
      props.includeTotalPages &&
      resultRows.length > 0 &&
      typeof resultRows[0] === "string" &&
      resultRows[0].startsWith("totalPages:")
    ) {
      const serverTotalPages = parseInt(resultRows[0].split(":")[1], 10);
      if (!isNaN(serverTotalPages) && props.ChangeTotalPages != null) {
        // If we got fewer results than requested on the first load, there is only 1 page.
        if (serverTotalPages <= 1) {
          props.ChangeTotalPages(1);
        } else {
          props.ChangeTotalPages(serverTotalPages);
        }
      }
      // remove the totalPages token
      resultRows = resultRows.slice(1);
    }

    const listComplete = resultRows.length < props.amount;
    if (
      listComplete !== props.listComplete &&
      props.ChangeListCompleted != null
    ) {
      props.ChangeListCompleted(listComplete);
    }

    let resultVideos = resultRows;
    if (needExtraOnFirst) {
      resultVideos = resultRows.filter(
        (video) => video.id !== props.topVideo.id,
      );
    }

    if (props.loadsCompleted > 1 && videos != null && !props.isPaginated) {
      SetVideos(videos.concat(resultVideos));
      return;
    }
    SetVideos(resultVideos);
  }

  const filteredVideos = videos?.filter((v) => v?.id != null);

  const halfLengthOfVideos = Math.floor(filteredVideos.length / 2);

  const bannerAdIndex =
    halfLengthOfVideos % 2 === 0
      ? halfLengthOfVideos - 1
      : halfLengthOfVideos + 1;

  useEffect(() => {
    if (props.loadingTopVideo) {
      return;
    }

    if (props.loadsCompleted > 0) {
      if (
        props.loadsCompleted <= 1 &&
        props.videos == null &&
        (!videos || videos.length === 0)
      ) {
        SetVideos([]);
      }
      RetrieveVideos();
      return;
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.loadsCompleted, props.videos, props.amount, props.loadingTopVideo]);

  useEffect(() => {
    if (props.replaceRecommended) {
      ChangeRecommendedVideos(videos);
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [videos]);

  return (
    <>
      <div
        className={"videoList " + (props.singleRow ? "singleRow" : "multiRow")}
      >
        {props.singleRow ? (
          <VideoListSingleRow
            {...props}
            videos={videos?.filter((v) => v?.id != null)}
            numberOfPlaceholders={props.amount}
          />
        ) : isMobile && !props.topVideo && window.location.pathname === "/" ? (
          <div style={{ display: "flex", flexDirection: "column" }}>
            <VideoListMultiRow
              {...props}
              adAtEnd={false}
              videos={filteredVideos.slice(0, bannerAdIndex)}
              numberOfPlaceholders={
                filteredVideos.slice(0, bannerAdIndex).length - 1
              }
              loadingTopVideo={props.loadingTopVideo}
              isRecommendedAndMobile={true}
              firstList={true}
            />
            <Ad type="banner" />
            <VideoListMultiRow
              {...props}
              hideHeader={true}
              adAtStart={false}
              adAtEnd={true}
              videos={filteredVideos.slice(bannerAdIndex)}
              numberOfPlaceholders={
                filteredVideos.slice(bannerAdIndex).length - 1
              }
              loadingTopVideo={props.loadingTopVideo}
              isRecommendedAndMobile={true}
              firstList={false}
            />
          </div>
        ) : (
          <VideoListMultiRow
            {...props}
            videos={filteredVideos}
            numberOfPlaceholders={props.amount}
            loadingTopVideo={props.loadingTopVideo}
            hideBoxAdsOnMobileRecommended={isMobile}
          />
        )}
      </div>
    </>
  );
}

export default VideoList;
